import React, { useState } from 'react';
import 'react-hawksearch/dist/esm/react-hawksearch.css';

import HawksearchPreview from 'components/HawksearchPreview';
import PreviewSearch from './previewSearch';
import PreviewClient from 'net/PreviewClient';

import 'rheostat/css/rheostat.css';
import 'react-dates/lib/css/_datepicker.css';

import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet';
import cssInterface from 'react-with-styles-interface-css';
import RheostatDefaultTheme from 'rheostat/lib/themes/DefaultTheme';
import ReactDatesDefaultTheme from 'react-dates/lib/theme/DefaultTheme';
import AppState from 'AppState';
import Spinner from 'components/shared/Spinner';
import { ClientDataResponse } from '../models/ClientDataResponse';

ThemedStyleSheet.registerInterface(cssInterface);
ThemedStyleSheet.registerTheme({
	...RheostatDefaultTheme,
	...ReactDatesDefaultTheme,
});

async function getClientGuid(
	siteDirectory: string,
	setClientGuid: React.Dispatch<React.SetStateAction<string>>
): Promise<void> {
	let clientData = {} as ClientDataResponse;
	const client = new PreviewClient(AppState.config);

	try {
		clientData = await client.getClientData({
			SiteDirectory: siteDirectory || '',
		});
	} catch (error) {
		console.error('Detect client request error:', error);
	}
	if (!clientData.ClientGuid) {
		console.error("Couldn't detect client identifier!");
	} else {
		AppState.config.clientGuid = clientData.ClientGuid;
		setClientGuid(clientData.ClientGuid);
		AppState.config.clientIndexes = clientData.ClientIndexes;
		AppState.config.currentSearchIndex = clientData.CurrentIndex;
		AppState.hawkConfig.indexName = clientData.CurrentIndex;
	}
}

function Preview(props) {
	// const [clientGuid, setClientGuid] = useState('');
	// getClientGuid(props.siteDirectory, setClientGuid);

	AppState.config.clientGuid = props.clientGuid;
	AppState.hawkConfig.clientGuid = props.clientGuid;
	AppState.config.clientIndexes = [];
	AppState.config.currentSearchIndex = props.indexName;
	AppState.hawkConfig.indexName = props.indexName;
	// AppState.config.compareItemsURL = '/api/compare';
	// AppState.hawkConfig.trackEventUrl = process.env.REACT_APP_HAWK_TRACK_EVENT_URL;

	if (props.clientGuid) {
		return (
			<HawksearchPreview
				config={AppState.config}
				settings={AppState.settings}
				siteDirectory={props.siteDirectory}
			>
				<PreviewSearch history={props.history} location={props.location} />
			</HawksearchPreview>
		);
	} else {
		return <Spinner isVisible={true} />;
	}
}

export default Preview;
